import { useQuery } from '@tanstack/react-query';
import { IMMIGRATION_STATUS_LIST_KEY } from '../../utils/constants/queryKeys';
import { getImmigrationStatusList } from '../services/fn-api/ImmigrationStatus';

export const useGetImmigrationStatusList = () => {
  return useQuery({
    queryKey: [IMMIGRATION_STATUS_LIST_KEY],
    queryFn: () => getImmigrationStatusList(),
  });
};
